import { render } from "./redirection.vue?vue&type=template&id=56b9c3b2&scoped=true"
import script from "./redirection.vue?vue&type=script&lang=js"
export * from "./redirection.vue?vue&type=script&lang=js"

import "./redirection.vue?vue&type=style&index=0&id=56b9c3b2&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b9c3b2"]])

export default __exports__